import React from "react";
import { TriangleAlert, Trash2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const BulkDeleteDialog = ({ open, onOpenChange, count, deleting, onConfirm }) => {
  const handleConfirm = (event) => {
    event.preventDefault();
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl" data-testid="bulk-delete-dialog">
        <AlertDialogHeader>
          <div className="w-11 h-11 rounded-xl bg-[color:var(--vault-error-bg)] text-[color:var(--vault-error)] flex items-center justify-center mb-1">
            <TriangleAlert size={22} />
          </div>
          <AlertDialogTitle>Delete {count} selected {count === 1 ? "item" : "items"}?</AlertDialogTitle>
          <AlertDialogDescription data-testid="bulk-delete-warning">
            This permanently removes the selected vault {count === 1 ? "entry" : "entries"} and any sharing connected to them. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting} className="rounded-xl" data-testid="bulk-delete-cancel-button">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={deleting}
            onClick={handleConfirm}
            className="rounded-xl bg-[color:var(--vault-error)] hover:bg-[#b91c1c] text-white"
            data-testid="bulk-delete-confirm-button"
          >
            <Trash2 size={16} className="mr-1.5" />
            {deleting ? "Deleting…" : `Delete ${count} ${count === 1 ? "item" : "items"}`}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};